<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: "App",
    beforeCreate() {
        const siteId = this.$route.params.siteId;
        localStorage.setItem("siteId", siteId);

        const isInIframe = window !== window.top;
        const isSpecial = this.$route.query.special === "true";
        
        console.log('🔴 App beforeCreate:', {
            isInIframe,
            isSpecial,
            siteId,
            windowSelf: window.self === window,
            windowTop: window === window.top,
            parentWindow: window.parent === window,
            location: window.location.href,
            timestamp: new Date().toISOString()
        });

        const special = this.$route.query.special;
        if (special === "true") {
            console.log('🟡 Special mode activated');
            document.body.classList.add("special-background");
            document.documentElement.classList.add("special-background");
            document.documentElement.style.overflow = "hidden";
            document.body.style.overflow = "hidden";
            document.body.style.height = "100vh";
            document.documentElement.style.height = "100vh";
            document.body.style.position = "fixed";
            document.body.style.width = "100%";
            document.body.style.top = "0";
            document.body.style.left = "0";
        }
        const docSup = this.$route.query.docSup;
        if (docSup === "true") {
            document.body.classList.add("doc-sup");
        }
    },
    mounted() {
        console.log('🔴 App mounted');
        
        document.addEventListener('click', (event) => {
            console.log('🔴 Global click detected:', {
                target: event.target.tagName,
                id: event.target.id,
                className: event.target.className,
                isTrusted: event.isTrusted,
                clientX: event.clientX,
                clientY: event.clientY,
                timeStamp: event.timeStamp,
                type: event.type
            });
        }, true);

        document.addEventListener('submit', (event) => {
            console.log('🔴 Global submit detected:', {
                target: event.target.tagName,
                isTrusted: event.isTrusted,
                timeStamp: event.timeStamp
            });
        }, true);
    }
};
</script>

<style>
/* Modern Font Import */
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');

/* Modern CSS Variables */
:root {
    /* Colors */
    --primary: #6366f1;
    --primary-light: #818cf8;
    --primary-dark: #4f46e5;
    --secondary: #8b5cf6;
    --accent: #10b981;
    --success: #059669;
    --warning: #f59e0b;
    --error: #ef4444;
    
    /* Grays */
    --gray-50: #f9fafb;
    --gray-100: #f3f4f6;
    --gray-200: #e5e7eb;
    --gray-300: #d1d5db;
    --gray-400: #9ca3af;
    --gray-500: #6b7280;
    --gray-600: #4b5563;
    --gray-700: #374151;
    --gray-800: #1f2937;
    --gray-900: #111827;
    
    /* Background */
    --bg-primary: #ffffff;
    --bg-secondary: #f8fafc;
    --bg-tertiary: #f1f5f9;
    
    /* Text */
    --text-primary: #1f2937;
    --text-secondary: #4b5563;
    --text-tertiary: #6b7280;
    
    /* Border */
    --border-light: #e5e7eb;
    --border-medium: #d1d5db;
    --border-dark: #9ca3af;
    
    /* Spacing */
    --space-1: 0.25rem;
    --space-2: 0.5rem;
    --space-3: 0.75rem;
    --space-4: 1rem;
    --space-6: 1.5rem;
    --space-8: 2rem;
    --space-12: 3rem;
    --space-16: 4rem;
    
    /* Border Radius */
    --radius-sm: 0.375rem;
    --radius-md: 0.5rem;
    --radius-lg: 0.75rem;
    --radius-xl: 1rem;
    --radius-2xl: 1.5rem;
    
    /* Transitions */
    --transition: 300ms ease-in-out;
}

/* Reset */
* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

/* HTML - Ana arkaplan burası */
html {
    height: 100%;
    overflow-x: hidden;
}

/* Body - Normal scroll için */
body {
    min-height: 100vh;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    color: var(--text-primary);
    line-height: 1.6;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: transparent;
    overflow-x: hidden;
    width: 100%;
    background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
    background-attachment: fixed;
    background-repeat: no-repeat;
    background-size: cover;
}

/* Subtle pattern overlay */
body::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: 
        radial-gradient(circle at 25px 25px, rgba(99, 102, 241, 0.04) 2px, transparent 0),
        radial-gradient(circle at 75px 75px, rgba(139, 92, 246, 0.04) 2px, transparent 0);
    background-size: 100px 100px;
    pointer-events: none;
    z-index: -1;
}

/* Special backgrounds */
body.special-background,
body.doc-sup {
    background: transparent !important;
    overflow: hidden !important;
    position: fixed !important;
    width: 100% !important;
    height: 100vh !important;
    top: 0 !important;
    left: 0 !important;
}

html.special-background,
html.doc-sup {
    background: transparent !important;
    overflow: hidden !important;
    height: 100vh !important;
}

body.special-background::before,
body.doc-sup::before {
    display: none;
}

/* Special app container */
body.special-background #app,
body.doc-sup #app {
    overflow: hidden !important;
    height: 100vh !important;
    position: fixed !important;
    width: 100% !important;
}

/* App container */
#app {
    min-height: 100vh;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: var(--text-primary);
    overflow-x: hidden;
    width: 100%;
    max-width: 100vw;
}

/* Modern scrollbar */
::-webkit-scrollbar {
    width: 4px;
}

::-webkit-scrollbar-track {
    background: rgba(241, 245, 249, 0.3);
    border-radius: 2px;
}

::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, var(--primary) 0%, var(--secondary) 100%);
    border-radius: 2px;
}

::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(135deg, var(--primary-dark) 0%, var(--secondary) 100%);
}

/* Modern selection */
::selection {
    background: rgba(99, 102, 241, 0.2);
    color: var(--text-primary);
}

/* Modern focus */
*:focus-visible {
    outline: 2px solid var(--primary);
    outline-offset: 2px;
    border-radius: var(--radius-sm);
}

/* Typography */
h1, h2, h3, h4, h5, h6 {
    font-weight: 600;
    line-height: 1.2;
    color: var(--text-primary);
    margin: 0;
}

h1 {
    font-size: clamp(1.875rem, 4vw, 3rem);
    font-weight: 700;
    letter-spacing: -0.025em;
}

h2 {
    font-size: clamp(1.5rem, 3vw, 2.25rem);
    font-weight: 600;
    letter-spacing: -0.025em;
}

h3 {
    font-size: clamp(1.25rem, 2.5vw, 1.875rem);
    font-weight: 600;
}

p {
    margin: 0;
    color: var(--text-secondary);
}

/* Modern form elements */
button {
    font-family: inherit;
    cursor: pointer;
    border: none;
    border-radius: var(--radius-md);
    transition: all var(--transition);
    font-weight: 500;
}

button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

input, textarea, select {
    font-family: inherit;
    border-radius: var(--radius-md);
    border: 1px solid var(--border-light);
    transition: all var(--transition);
}

input:focus, textarea:focus, select:focus {
    outline: none;
    border-color: var(--primary);
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

/* Animations */
.fade-enter-active, .fade-leave-active {
    transition: all var(--transition);
}

.fade-enter-from, .fade-leave-to {
    opacity: 0;
    transform: translateY(10px);
}

.slide-enter-active, .slide-leave-active {
    transition: all var(--transition);
}

.slide-enter-from {
    transform: translateX(-100%);
    opacity: 0;
}

.slide-leave-to {
    transform: translateX(100%);
    opacity: 0;
}

/* Loading state */
.loading {
    position: relative;
    overflow: hidden;
}

.loading::after {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
    animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
    0% { left: -100%; }
    100% { left: 100%; }
}

/* Responsive */
@media (max-width: 640px) {
    :root {
        --space-4: 0.75rem;
        --space-6: 1rem;
        --space-8: 1.5rem;
    }
}

/* Dark mode devre dışı - Her zaman açık tema kullan */

/* Performance */
* {
    transform: translateZ(0);
}

/* Accessibility */
@media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
        animation-duration: 0.01ms !important;
        animation-iteration-count: 1 !important;
        transition-duration: 0.01ms !important;
    }
}
</style>